var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// (webpack)/~/isarray/index.js
// module id = 423
// module chunks = 1 4 5 6 8 9 10 12 13 14 19 21 24 27 28 57